module.exports = __webpack_public_path__ + "img/anaerobic-bioreactor.96b1f83c.svg";